import React__default, { useState, useEffect } from 'react';
import { Box, Grid, FormControl, MenuItem } from '@mui/material';
import clsx from 'clsx';
import { useTranslation } from 'react-i18next';
import KSelect from '../KSelect/index.js';

var Sort = function Sort(_a) {
    var sortList = _a.sortList, defaultSortValue = _a.defaultSortValue, onSortChange = _a.onSortChange, className = _a.className, customDropdownIcon = _a.customDropdownIcon, _b = _a.testId, testId = _b === void 0 ? "Sort" : _b, id = _a.id, sx = _a.sx;
    var t = useTranslation("refront-components").t;
    var _c = useState(undefined), currentSort = _c[0], setCurrentSort = _c[1];
    var handleSortChange = function (event) {
        setCurrentSort(event.target.value || defaultSortValue);
        onSortChange(event.target.value || defaultSortValue);
    };
    useEffect(function () {
        setCurrentSort(defaultSortValue);
    }, [defaultSortValue]);
    return (React__default.createElement(Box, { "data-testid": testId, id: id, className: clsx("Sort", className) },
        React__default.createElement(Grid, { item: true },
            React__default.createElement(FormControl, null,
                React__default.createElement(KSelect, { value: currentSort || defaultSortValue, onChange: handleSortChange, IconComponent: customDropdownIcon, SelectDisplayProps: { "aria-label": t("components-sort-select-label") }, sx: sx }, sortList.map(function (sort) { return (React__default.createElement(MenuItem, { key: sort.value, value: sort.value, sx: {
                        "& .MuiBox-root": {
                            flexDirection: "row-reverse"
                        }
                    } }, sort.label)); }))))));
};

export { Sort as default };
//# sourceMappingURL=index.js.map
